module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAATRJREFUSEvdlD1KBEEQhV/BBJOYCSajxuaGIsYjHmCTYRmhOlRQ8AarYLIsqPRPsHgEkz2AeAEDcw0XczHpkpE2W2d7Zu3ETrt4H/Wq6hESP0qsj38MMMZcicgAwDUz3xCR9LHzV4u01q8AthpRIprleT6sqmreFdIGOAQwBbAeROdENGTmWRdI65CttRveewvgKHTS2DQpiuKiLMvPGFDUFhljagBjEVkLoOcsywZ1Xb8sg0QBGhHn3Lb3fioiB0H0A8CZUuquDRINaEREhIwxp0Q0EpE8dPMgIsdKqfdFoE6AHwFr7Y73/h7AboA8MvN+SsATM++tDGgscs6diMjln1u0aMhEdM7MtysPOdmaJj00rXXaqNBavwHYTBZ2yeN6WcbE/ve65Fjxb3u7FPepTQ74AqO2mRnEigykAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/more.png
// module id = uty8
// module chunks = 2